import styled from "styled-components"

export const StyledContactUsWidget = styled.div`
    font-size: 22px;
`
